import axios from 'axios';
import * as  actionTypes from './actionTypes';

export const authstart = () => {
   return {
       type: actionTypes.AUTH_START
   }
 
}
 
export const authSuccess = (token) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token
    }
 
 }

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
 
 }

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    return {
        type: actionTypes.AUTH_LOGOUT
    }
 
 }
export const checkAuthTimeout = expirationTime => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 10000)
    }
} 
export const authLogin = (username, password) => {
    return dispatch => {
        dispatch(authstart());
        const postObj = {username:username,
                         password: password};
        axios.post('https://apa-reference-finder-backend-3.herokuapp.com/rest-auth/login/', postObj)
        .then(res=> {
            const token = res.data.key;
            const expirationDate = new Date(new Date().getTime() + 3600 * 10000);
            localStorage.setItem('token', token);
            localStorage.setItem('expirationDate', expirationDate);
            dispatch(authSuccess(token));
            dispatch(checkAuthTimeout(3600));
        }) 
        .catch(err => {dispatch(authFail(err));
        })   
    }
  
 }

export const authSignup = (username, email, password1, password2) => {
    return dispatch => {
        dispatch(authstart());
        const postObjtoo = {username:username,
                         email: email,    
                         password1: password1,
                         password2: password2};
        axios.post('https://apa-reference-finder-backend-3.herokuapp.com/rest-auth/registration/', postObjtoo)
        .then(res=> {
            const token = res.data.key;
            const expirationDate = new Date(new Date().getTime() + 3600 * 10000);
            localStorage.setItem('token', token);
            localStorage.setItem('expirationDate', expirationDate);
            dispatch(authSuccess(token));
            dispatch(checkAuthTimeout(3600));
        }) 
        .catch(err => {dispatch(authFail(err));
        })   
    }
 
 } 

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (token === undefined) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if ( expirationDate <= new Date() ) {
                dispatch(logout());
            } else {
                dispatch(authSuccess(token));
                dispatch(checkAuthTimeout( (expirationDate.getTime() - new Date().getTime()) / 1000) );
            }
        }
    }
}

export const confirmLogout = () => dispatch => {
    if (window.confirm("Click Ok to logout")) {
        dispatch(logout());
    }
    
}
